import { useLayoutEffect } from 'react';

import { useLocation } from 'react-router-dom';

export const useScrollToTopOnPathChange = (ref) => {
  const location = useLocation();
  // Scroll to top if path changes
  useLayoutEffect(() => {
    ref?.current?.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, ref?.current]);
};
